// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"60":"9c3e29a1","293":"e8782b04"}[chunkId] + ".chunk.css";
};